// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"LocationLabel3_badgeWrapper__K_WZx","locationBadge":"LocationLabel3_locationBadge__wwmJ4","online-icon":"LocationLabel3_online-icon__kA_TF"};